import { Box, Button, Container, Group, Stack, Title } from "@mantine/core";
import { useNavigate, useParams, Link } from "react-router-dom";
import UserNewFeed, { NewsItem } from "components/profile/UserNewFeed";

/**
 * TeamNews
 *
 * Team-scoped news page. Route: /teams/:teamId/news
 * - Provides a back button to return to the team profile
 * - Reuses the UserNewFeed component; later wire items from API by teamId
 */
export default function TeamNews() {
  const { teamId } = useParams<{ teamId: string }>();
  const navigate = useNavigate();

  // TODO: Replace with useTeamNewsQuery(teamId)
  const items: NewsItem[] = [
    { id: "n1", title: "Scrim block scheduled for Friday", postedAt: new Date().toISOString(), excerpt: "GM posted the scrim schedule." },
    { id: "n2", title: "Roster is locked for this week", postedAt: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(), excerpt: "No changes expected." },
  ];

  const backHref = `/teams/${teamId ?? ""}`;

  return (
    <Container size="lg" p="md">
      <Stack gap="md">
        <Group justify="space-between" align="center">
          <Title order={3}>Team News</Title>
          {/* Single reliable back action: explicit link back to the team profile */}
          <Button component={Link} to={backHref} variant="light">
            Back to Team
          </Button>
        </Group>

        <Box>
          <UserNewFeed title="Team News Feed" items={items} />
        </Box>
      </Stack>
    </Container>
  );
}
